import { createGrid, createRecordSource } from "../rcsgrid";
import { defaultFieldInfo, getRightsData } from "../../Tools/Tools";
import { EditStyle, Prefixes } from "../../Tools/ProjectX";
import { AxiosRequest } from "../../../Url";

export async function accountsPeriodGrid(grid: createGrid, source: createRecordSource, props, data) {
  source.onHandleRequest = handlePeriodRequest(props);
  const columns = {
    title: [
      {
        fieldName: "FromDate",
        title: "Начало",
        width: 120,
        level: 0,
        fieldInfo: { ...defaultFieldInfo, EditStyle: EditStyle.PickList + EditStyle.Calendar },
      },
      {
        fieldName: "TillDate",
        title: "Конец",
        width: 120,
        level: 0,
        fieldInfo: { ...defaultFieldInfo, EditStyle: EditStyle.PickList + EditStyle.Calendar },
      },
    ],
  };
  source.rights = getRightsData(0);
  grid.setColumns(columns);
  await source.open();
  await grid.setSource(source);
  if (props.ID) {
    await grid.refreshSource(props.ID);
  } else await grid.refreshSource();
  await grid.updateGridSize();
}

export const handlePeriodRequest = (props: { SectionID?: string | number; GroupID: string }) => {
  return (request) => {
    const params = new Map();
    params
      .set("prefix", Prefixes.acc)
      .set("comand", "HandlePeriodTable")
      .set("ObjType", "-1")
      .set("SectionID", props.SectionID)
      .set("GroupID", props.GroupID);
    return AxiosRequest(true, params, request);
  };
};
